jQuery(document).on("gform_page_loaded", function (event, formId) {
  if (formId !== 4) return;
  jQuery("#gf_progressbar_wrapper_4").addClass("is-updating");
});

jQuery(document).on("gform_post_render", function (event, formId, currentPage) {
  if (formId !== 4) return;

  if (currentPage === undefined) return;
  const TOTAL_QUESTIONS = 15;
  const scoreInput = jQuery("#gform_4 .score input");

  jQuery(document)
    .off("change.gf4")
    .on("change.gf4", '#gform_4 input[type="radio"]', function () {
      updateScore();
    });

  function updateScore() {
    let currScore = 0;
    jQuery('#gform_4 input[type="radio"]:checked').each(function () {
      currScore += parseInt(jQuery(this).val()) || 0;
    });
    console.log("Huidige score:", currScore);
    scoreInput.val(currScore);
  }

  setTimeout(function () {
    updateProgressBar(currentPage);
  }, 50);

  function updateProgressBar(page) {
    const wrapper = jQuery("#gf_progressbar_wrapper_4");
    if (!wrapper.length) return;

    if (page === 1) {
      wrapper.addClass("is-updating");
      return;
    }

    const adjustedCurrent = page - 1;
    const percent = Math.round((adjustedCurrent / TOTAL_QUESTIONS) * 100);

    wrapper
      .find(".gf_progressbar_title")
      .html(
        'Casus <span class="gf_step_current_page">' +
          adjustedCurrent +
          "</span>" +
          ' van <span class="gf_step_page_count">' +
          TOTAL_QUESTIONS +
          "</span>",
      );

    wrapper
      .find(".gf_progressbar_percentage")
      .css("width", percent + "%")
      .find("span")
      .text(percent + "%");

    // Wacht tot de CSS transition van fade-out klaar is, dan fade-in
    wrapper.removeClass("is-updating");
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const risicoprofielen = document.querySelectorAll(".risicoprofiel");
  if (risicoprofielen.length === 0) return;

  const score = parseInt(
    new URLSearchParams(window.location.search).get("score"),
  );
  if (score) {
    risicoprofielen.forEach((profiel) => {
      const min = parseInt(profiel.dataset.min);
      const max = parseInt(profiel.dataset.max);
      profiel.classList.toggle("active", score >= min && score <= max);
    });
  }
});
